import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const Dashboard = lazy(() => import("./main"));

export const dashboardRoutes = {
  children: [
    {
      path: "dashboard",
      element: <Dashboard />,
      errorElement: <ErrorBoundary />
    }
  ]
};
